import { useContext } from "react";
import SiteLanguageContext from "./SiteLanguageContext";

export function useSiteLanguage() {
	const ctx = useContext(SiteLanguageContext);
	if (!ctx)
		throw new Error("useSiteLanguage must be used within SiteLanguageProvider");
	return ctx;
}
